import { Grid } from '@mui/material';

// Components
import { IBookmarkCompany } from 'src/model/bookmark';
import CompanyBookmarkCard from 'src/features/Bookmark/CompanyBookmarkList/CompanyBookmarkCard';

interface IListCompanyBookmarkProps {
  listBookmark: IBookmarkCompany[];
}

const CompanyBookmarkList = ({ listBookmark }: IListCompanyBookmarkProps) => {
  return (
    <Grid container spacing={2}>
      {listBookmark.map((dataBookmark: IBookmarkCompany, index) => {
        return (
          <Grid xs={12} md={6} lg={6} xl={4} key={`company-bookmark-${dataBookmark.uuid}-${index}`} item>
            <CompanyBookmarkCard dataBookmark={dataBookmark} />
          </Grid>
        );
      })}
    </Grid>
  );
};

export default CompanyBookmarkList;
